import { Mail, Phone, ShieldCheck } from "lucide-react";
import { PageHero, Container } from "@/components/site/blocks";
import { Reveal } from "@/components/site/motion";
import { useSeo } from "@/components/site/useSeo";
import { CONTACT } from "@/components/site/nav";
import { InquiryForm } from "@/components/site/InquiryForm";

export default function Contact() {
  useSeo("Contact", "Discuss a JEM partnership with John E. Mason. Request a screening, workshop, speaking engagement, or pilot.");
  return (
    <>
      <PageHero testid="contact-hero" label="Contact" lines={["Let's talk", <span key="p" className="italic text-[#F3C649]">partnership.</span>]}
        intro="Share a few details and John will follow up to discuss a screening, workshop, speaking engagement, or partnership." />
      <section className="pb-28" data-testid="contact-section">
        <Container className="grid gap-14 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <h2 className="label">Reach John directly</h2>
            <ul className="mt-6 space-y-4">
              <li><a href={`mailto:${CONTACT.email}`} className="group flex items-center gap-4 text-lg hover:text-[#F3C649]" data-testid="contact-email-link">
                <span className="rounded-full border border-[#D4AF37]/40 p-3"><Mail size={18} aria-hidden="true" className="text-[#F3C649]" /></span>{CONTACT.email}</a></li>
              <li><a href={`tel:${CONTACT.tel}`} className="group flex items-center gap-4 text-lg hover:text-[#F3C649]" data-testid="contact-phone-link">
                <span className="rounded-full border border-[#D4AF37]/40 p-3"><Phone size={18} aria-hidden="true" className="text-[#F3C649]" /></span>{CONTACT.phone}</a></li>
            </ul>
            <p className="mt-10 flex gap-3 rounded-2xl border border-[#D4AF37]/25 bg-[#12141C] p-5 text-sm leading-relaxed text-[#C8C5BB]">
              <ShieldCheck size={20} aria-hidden="true" className="shrink-0 text-[#F3C649]" />
              Please don't share medical or disability information in this form. We only need details about your organization and interest.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-8"><InquiryForm /></Reveal>
        </Container>
      </section>
    </>
  );
}
